import React, { Component } from "react";
import AttendanceDetails from "./AttendanceDetails.jsx";
import LeaveDetails from "./LeaveDetails.jsx";
import OTDetails from "./OTDetails.jsx";
import TravelDetails from "./TravelDetails.jsx";


class FormDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formType: null,
            instanceId: null
        }
    }

    componentDidMount() {
        const { match } = this.props;
        if(match.params.formType && match.params.id) {
            this.setState({
                formType: match.params.formType,
                instanceId: match.params.id
            })
        }
    }

    goToList = () => {
        this.props.history.push('/forms')
    }

    render() {

        const { 
            formType,
            instanceId
        } = this.state;

        return (
        <div className="content">
            {formType === "attendance" &&
                <AttendanceDetails instanceId={instanceId} goToList={this.goToList} />
            }
            {formType === "leave-undertime" &&
                <LeaveDetails instanceId={instanceId} goToList={this.goToList} />
            }
            {formType === "travel-order" &&
                <TravelDetails instanceId={instanceId} goToList={this.goToList} />
            }
            {formType === "ot-request" &&
                <OTDetails instanceId={instanceId} goToList={this.goToList} />
            }
        </div>
        );
    }
}

export default FormDetails;
